module.exports = __webpack_public_path__ + "static/media/lon_lia_per.1f2857eb.png";